import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageInfoService } from 'src/app/_metronic/layout';
import { Subject } from 'rxjs';
import { ChangePassword2Component } from '../../components/change-password2/change-password2.component';
import { PageTitleService } from '../../../../services/page-title/page-title.service'

@Component({
  selector: 'app-change-password-main',
  templateUrl: './change-password-main.component.html',
  styleUrls: ['./change-password-main.component.scss']
})
export class ChangePasswordMainComponent implements OnInit {

  @ViewChild('changePassword')
  changePassword2Component!: ChangePassword2Component;

  subjectTabSelected: Subject<string> = new Subject();

  constructor(
    private translateService: TranslateService,
    private pageInfoService: PageInfoService,
    private changeDetectorRef: ChangeDetectorRef,
    private pageTitle: PageTitleService,
  ) {}

  ngOnInit(): void {
    this.pageTitle.set(this.translateService.instant('MENU.CHANGE_PASSWORD'));
      this.changeDetectorRef.detectChanges();

  }



}
